import React from 'react';
import type { ExperienceViewerProps } from './types';
import { App } from './lib/components/ResponsiveApp';
import type { ResponsiveAppProps } from './lib/types';

/**
 * Main orchestrator component for the Libertify experience.
 *
 * Renders the full consumption experience (video + document + chat + layout)
 * in either "viewer" mode (public) or "creator" mode (admin preview with edit controls).
 *
 * Wraps the internal ResponsiveApp with ExperienceViewer props mapping.
 */
export const ExperienceViewer: React.FC<ExperienceViewerProps> = ({
  mode,
  publication,
  projectId,
  publicationId,
  organizationId,
  organizationSlug,
  instanceSlug,
  headers,
  responseHeaders,
  isPreview,
  creatorToolbar,
  creatorToolbarMobile,
  creatorDocumentFooter,
  creatorFooter,
  onShareClick,
  newMode,
  videoOverride,
  isDocHeyGenius,
  isAudioOnly,
  isMediaGenerating,
}) => {
  const isCreator = mode === 'creator';
  const appProps: ResponsiveAppProps = {
    params: { type: '', projectId, publicationId },
    publication,
    headers,
    responseHeaders,
    isPreview,
    organizationId,
    organizationSlug,
    instanceSlug,
    publicationStatus: publication ? 200 : undefined,
    creatorToolbar: isCreator ? creatorToolbar : undefined,
    creatorToolbarMobile: isCreator ? creatorToolbarMobile : undefined,
    creatorDocumentFooter: isCreator ? creatorDocumentFooter : undefined,
    creatorFooter: isCreator ? creatorFooter : undefined,
    onShareClick,
    newMode,
    videoOverride,
    isDocHeyGenius,
    isAudioOnly,
    isMediaGenerating,
  };

  return (
    <div
      data-testid="experience-viewer"
      data-mode={mode}
      style={{ height: '100%' }}
    >
      <App {...appProps} />
    </div>
  );
};
